import {gql} from "@apollo/client";

export const getCategories = gql`
  query getList {
    categories {
      id
      name
      position
      time
      details
    }
  }
`

export const getCategoryById = gql`
  query getItem($id: ID!) {
    category( id: $id) {
      id
      name
      time
      details
    }
  }
`

export const createCategoryMutation = gql`
  mutation createCategory($name: String!, $position: Int, $time: String, $details: String){
    createCategory(
      input: {
        name: $name,
        position: $position,
        time: $time,
        details: $details
      }) {
      category {
        id
        name
        position
        time
        details
      }
    }
  }
`

export const updateCategoryMutation = gql`
  mutation updateCategory($id: ID!, $name: String!, $position: Int, $time: String, $details: String){
    updateCategory(
      input: {
        id: $id,
        name: $name,
        position: $position,
        time: $time,
        details: $details
      }) {
      category {
        id
        name
        position
        time
        details
      }
    }
  }
`

export const deleteCategoryMutation = gql`
  mutation deleteCategory($id: ID!){
    deleteCategory(
      input: {id: $id}
    ) {
      category {
        id
      }
    }
  }
`
